import http from "../httpService";
import {getBaseUrl} from "../../config";


export const updateAdminServiceChangePersonWalletBalance = data => {
  return http.put(
    `${getBaseUrl()}/admin_service_change_person_wallet_balance`,
    data
  );
};
